const schema = () => ({
  type: 'object',
  required: [],
  properties: {
    wolesale_items: {
      type: 'array',
      title: ' ',
      minItems: 1,
      uniqueItems: true,
      items: {
        type: 'object',
        title: '',
        required: ['quantity', 'discount_amount'],
        properties: {
          quantity: {
            type: 'number',
            title: 'تعداد',
          },
          discount_amount: {
            type: 'number',
            title: 'مقدار تخفیف',
          },
          // discount_percent: {
          //   type: 'number',
          //   title: 'درصد تخفیف',
          // },
        },
      },
    },
  },
});

export default schema;
